import Vue from 'vue'
import VueRouter from 'vue-router'

// import Constants from '@/constants'

import Landing from '@/pages/landing'
import Service from '@/pages/service'
import About from '@/pages/about'
import Testimonials from '@/pages/testimonials'
import Opportunities from '@/pages/opportunities'
import OpportunitiesForm from '@/pages/opportunities/form'
import Contact from '@/pages/contact'

import NotFound from '@/pages/notfound'

Vue.use(VueRouter)

var vueRouter = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      id: 0,
      title: 'Landing',
      component: Landing
    },
    // { // no default service
    //   path: '/service',
    //   name: 'service',
    //   id: 0,
    //   title: 'Service',
    //   component: Service
    // },
    {
      path: '/service/:name',
      name: 'service.name',
      id: 0,
      title: 'Service-Name',
      component: Service
    },
    {
      path: '/about',
      name: 'about',
      id: 0,
      title: 'About',
      component: About
    },
    {
      path: '/testimonials',
      name: 'testimonials',
      id: 0,
      title: 'Testimonials',
      component: Testimonials
    },
    {
      path: '/opportunities',
      name: 'opportunities',
      id: 0,
      title: 'Opportunities',
      component: Opportunities
    },
    {
      path: '/opportunities/form',
      name: 'opportunities.form',
      id: 0,
      title: 'OpportunitiesForm',
      component: OpportunitiesForm
    },
    {
      path: '/contact',
      name: 'contact',
      id: 0,
      title: 'Contact',
      component: Contact
    },
    {
      path: '*',
      name: 'notfound',
      id: 404,
      title: 'Not Found',
      component: NotFound
    }
  ]
})

export default vueRouter
